import { Button, Col, Container, Row } from "react-bootstrap"
import Header from "../components/Header"
import { Link } from 'react-router-dom';
import { useEffect, useState } from "react";
import { fetchResearchData } from "../contexts/fetchData";


const DirectionComponent = props => {

    const { index } = props

    const [res, setRes] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const data = await fetchResearchData(index);
            setRes(data)
        }
        fetchData()
        return () => {
            setRes([]);
        }
    }, [index])

    return (
        <div className="main-comp mt-2 mb-2">
            
            <Row>
                <Col xs={{order: 2, span: 12}} sm={{order: (index % 2 === 0) ? 2 : 1, span: 6}} className="research-text">
                    <h6>{res.title}</h6>
                    <div>{res.shortDescription}</div>
                </Col>
                <Col className='text-center' xs={{order: 2, span: 12}} sm={{order: (index % 2 === 0) ? 1 : 2, span: 6}}>
                    <img src={`${process.env.PUBLIC_URL}/researchHome/${index}.png`} alt="" style={{ minHeight: '200px', width: '90%', objectFit: 'contain'}} />
                     
                </Col>
            </Row>
            <div className="text-end">
                <Link to={`/research${index || ""}`} style={{ textDecoration: 'none' }}>
                    <Button variant="link" style={{ padding: 0 }}>
                        Read More
                    </Button>
                </Link>
            </div>
        </div>
    )
}


const PageResearch = () => {

    return (
        <div>
            <Header />
            <Container>
                <Row>
                    <Col xl='6' xs='12'>
                        <DirectionComponent index={1} />
                    </Col>
                    <Col xl='6' xs='12'>
                        <DirectionComponent index={2} />
                    </Col>
                </Row>
                <Row>
                    <Col xl='6' xs='12'>
                        <DirectionComponent index={3} />
                    </Col>
                    <Col xl='6' xs='12'>
                        <DirectionComponent index={4} />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default PageResearch;